import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const navLinks = [
  { label: "기능", href: "#features" },
  { label: "대시보드", href: "#dashboard" },
  { label: "분석", href: "#analytics" },
  { label: "요금제", href: "#cta" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-[#0A0E14]/95 backdrop-blur-md border-b border-[#00D9FF]/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 h-[72px] flex items-center justify-between">
        {/* Logo */}
        <a href="#" className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://public.readdy.ai/ai/img_res/35b72bf3-4b7f-4858-926b-243fdf4afa99.png"
            alt="StreamClip AI Logo"
            className="h-9 w-9 object-contain"
          />
          <span
            className="text-white font-bold text-lg tracking-tight"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            StreamClip<span className="text-[#00D9FF]">AI</span>
          </span>
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="text-gray-400 hover:text-white text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              {link.label}
            </a>
          ))}
        </div>

        {/* Right Section */}
        <div className="hidden md:flex items-center gap-4">
          <div className="flex items-center gap-2 text-xs text-gray-400" style={{ fontFamily: "'JetBrains Mono', monospace" }}>
            <span className="w-2 h-2 flex items-center justify-center">
              <span className="w-1.5 h-1.5 rounded-full bg-[#10B981] animate-pulse inline-block" />
            </span>
            3,842 에피소드 처리 완료
          </div>
          <button className="text-gray-300 hover:text-white text-sm font-medium px-4 py-2 transition-colors cursor-pointer whitespace-nowrap">
            로그인
          </button>
          <button
            onClick={() => navigate("/onboarding")}
            className="bg-[#00D9FF] hover:bg-[#00D9FF]/90 text-[#0A0E14] text-sm font-bold px-5 py-2.5 rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            무료 체험 시작
          </button>
        </div>

        {/* Mobile toggle */}
        <button
          className="md:hidden w-8 h-8 flex items-center justify-center text-gray-300 cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`${menuOpen ? "ri-close-line" : "ri-menu-3-line"} text-xl`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-[#0A0E14]/98 border-t border-[#00D9FF]/10 px-6 py-4 flex flex-col gap-4">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="text-gray-300 text-sm py-2 cursor-pointer"
              onClick={() => setMenuOpen(false)}
            >
              {link.label}
            </a>
          ))}
          <button
            onClick={() => navigate("/onboarding")}
            className="bg-[#00D9FF] text-[#0A0E14] font-bold text-sm px-4 py-2.5 rounded-lg cursor-pointer whitespace-nowrap"
          >
            무료 체험 시작
          </button>
        </div>
      )}
    </nav>
  );
}
